import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // By default supabase-js coordinates token refreshes across browser
    // tabs with navigator.locks, and every query (even one that doesn't
    // touch auth at all) awaits getSession() first, which waits on that
    // lock. Backgrounded/suspended tabs (very common on mobile, but also
    // just leaving other portal tabs open) don't reliably release that
    // lock, so a fresh page's first query can hang forever waiting for it -
    // this is what made both the public job board and this dashboard spin
    // indefinitely for a logged-in user. Overriding lock to run the
    // callback immediately, with no cross-tab coordination at all, trades
    // a rare wasted duplicate refresh call (harmless) for never hanging -
    // the right tradeoff for a portal that's realistically one recruiter
    // across a couple of tabs, not many concurrent sessions racing to
    // refresh the same token.
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
});
